export default {
  medica: 'M',
  hospital: 'H'
}
